module.exports = __webpack_public_path__ + "media/images/math_wide_other-0abe69bc7ad16f51ed1b4e5877ac7dad.png";